<template>
  <label
    class="smart-checkbox inline-flex align-center mx-2 sm:mx-1 cursor-pointer"
    :class="{
      'text-ui-danger': error
    }">
    <input
      v-bind="$attrs"
      :value="value"
      :disabled="disabled"
      :checked="isChecked"
      class="smart-checkbox__input border-default rounded inline-block cursor-pointer"
      :class="{
        'smart-checkbox--selected': isChecked
      }"
      :type="type"
      @change="onChange"
    />
    <span
      v-if="labelValue"
      class="ml-1 inline-block smart-checkbox__label">
      {{ labelValue }}
    </span>
  </label>
</template>

<script>
// @flow
import { isArray, isUndef } from 'utils';

export default {
  name: 'SmartCheckbox',
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: null,
      required: false,
    },
    model: {
      default: null,
      required: false,
    },
    checked: {
      type: Boolean
    },
    error: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'checkbox'
    }
  },
  computed: {
    isChecked() {
      if (isUndef(this.model)) {
        return this.checked;
      }
      if (isArray(this.model)) {
        return this.model.indexOf(this.value) !== -1;
      }

      return this.model;
    },
    labelValue() {
      return this.label || this.value;
    }
  },
  methods: {
    onChange(event: InputEvent): void {
      if (this.disabled) { return; }
      let value = this.model;

      if (isArray(this.model)) {
        value = this.model.slice();
        const index = this.indexOfModel(this.value);

        if (index !== -1) {
          value.splice(index, 1);
        } else {
          value.push(this.value);
        }
      } else {
        value = !this.isChecked;
      }

      this.$emit('change', value, event);
    },
    indexOfModel(value: any): number {
      if (isArray(this.model)) {
        if (!this.model.length) { return -1; }
        let i = -1;
        const valueString = JSON.stringify(value);

        while (i++ < this.model.length) {
          const itemString = JSON.stringify(this.model[i]);
          if (itemString === valueString) { return i; }
        }
        return -1;
      }
      return this.model.indexOf(value);
    }
  }
};

</script>

<style lang="scss">
.smart-checkbox {
  &__input {
    position: relative;
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-progress-appearance: none;
    appearance: none;
    min-height: 1.125rem;
    height: 1.125rem;
    min-width: 1.125rem;
    width: 1.125rem;
    border-width: 2px;
    border-color: rgb(177,177,177);
    transition: $transition-sm-slow $transition-easing-default;
    transition-property: box-shadow, background;
    &:focus {
      outline: none;
    }
    &:focus, &:active {
      box-shadow: 0 0 0 3px rgba($color-brand-secondary, $font-opacity-sm);
    }
    &::before {
      content: "";
      position: absolute;
      width: 6px;
      height: 10px;
      border-radius: 1px;
      border: solid transparent;
      border-width: 0 3px 3px 0;
      transform: rotate(46deg) scale(.4);
      margin: 1px 4px;
      transition: border-color $transition-sm-slow $transition-easing-default,
                  transform $transition-sm-slow $transition-easing-default;
    }
    &:checked {
      &::before {
        border-color: $color-ui-white;
        transform: rotate(46deg);
      }
    }
  }
  &__label {
    user-select: none;
  }
  &--selected {
    background: $color-brand-secondary;
    border-color: $color-brand-secondary;
  }
}
</style>
